import React, { memo } from 'react'
import PropTypes from 'prop-types'
import { Box, Grid, Stack } from '@mui/material'
import DataRow from '../../../common/DataRow'
import DeviceVisual from './DeviceVisual'
import { DATA_ICONS } from '../utils/constants'

/**
 * Device details panel
 * Displays textual and visual information
 */
const DeviceDetailsPanel = memo(({ showImage, data, colors, theme, t_ }) => {
  return (
    <Box sx={{ flexGrow: 1, p: 2, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <Grid container spacing={2} sx={{ height: '100%', flexGrow: 1 }}>
        {/* Left Column: Textual Information */}
        <Grid
          item
          xs={showImage ? 7 : 12}
          sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', height: '100%' }}
        >
          <Stack spacing={1.5} sx={{ width: '100%', pr: showImage ? 1 : 0 }}>
            <DataRow
              icon={DATA_ICONS.active}
              label={t_('FO / PR')}
              value={data.active}
              highlight
              colors={colors}
              delay={100}
            />
            <DataRow
              icon={DATA_ICONS.part}
              label={t_('Jobs')}
              value={data.part}
              colors={colors}
              delay={200}
            />
            <DataRow
              icon={DATA_ICONS.operator}
              label={t_('Operator')}
              value={data.operator}
              colors={colors}
              delay={300}
            />
          </Stack>
        </Grid>

        {/* Right Column: Visual Image */}
        {showImage && (
          <Grid item xs={5} sx={{ height: '100%' }}>
            <DeviceVisual
              deviceType={data.deviceType}
              theme={theme}
              colors={colors}
            />
          </Grid>
        )}
      </Grid>
    </Box>
  )
})

DeviceDetailsPanel.displayName = 'DeviceDetailsPanel'

DeviceDetailsPanel.propTypes = {
  showImage: PropTypes.bool.isRequired,
  data: PropTypes.shape({
    active: PropTypes.string,
    part: PropTypes.string,
    operator: PropTypes.string,
    deviceType: PropTypes.string
  }).isRequired,
  colors: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
  t_: PropTypes.func.isRequired
}

export default DeviceDetailsPanel
